import Vue from 'vue'
import Router from 'vue-router'
import store from './store'

Vue.use(Router)

const router = new Router({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/pages',
      component: () => import('@/views/pages/Index'),
      children: [
             {
               name: 'Login',
               path: 'login',
               component: () => import('@/views/pages/Login'),
               meta: {
                notRequiresAuth: true,
              },
             },
      ],
   },
    {
       path: '/',
      component: () => import('@/views/dashboard/Index'),
      children: [
            {
              name: 'dashboard',
              path: '/',
              component: () => import('@/views/dashboard/Dashboard'),
              meta: {
              roles: ['Admin', 'Monitor'],
            },
            },
             {
               name: 'tanks',
               path: 'targets/tanks',
               component: () => import('@/views/dashboard/targets/TankList'),
               meta: {
                roles: ['Admin'],
              },
             },
             {
              name: 'temperatures',
              path: 'targets/temperatures',
              component: () => import('@/views/dashboard/targets/TemperatureList'),
              meta: {
               roles: ['Admin'],
             },
            },
            {
              name: 'tankview',
              path: 'targets/tankview/:id',
              component: () => import('@/views/dashboard/targets/TankView'),
              meta: {
               roles: ['Admin'],
             },
            },
            {
              name: 'temperatureview',
              path: 'targets/temperatureview/:id',
              component: () => import('@/views/dashboard/targets/TemperatureView'),
              meta: {
               roles: ['Admin'],
             },
            },
            {
              name: 'contacts',
              path: 'contacts/contactList',
              component: () => import('@/views/dashboard/contacts/ContactList'),
              meta: {
               roles: ['Admin'],
             },
            },
            {
              name: 'contact',
              path: 'contacts/contact/:id',
              component: () => import('@/views/dashboard/contacts/Contact'),
              meta: {
               roles: ['Admin'],
             },
            },
            {
              name: 'currentAlerts',
              path: 'alerts/currentAlerts',
              component: () => import('@/views/dashboard/alerts/CurrentAlertList'),
              meta: {
               roles: ['Admin'],
             },
            },
            {
              name: 'alert',
              path: 'alerts/alert/:id',
              component: () => import('@/views/dashboard/alerts/Alert'),
              meta: {
               roles: ['Admin'],
             },
            },
            {
              name: 'temperatureRangeDateReport',
              path: 'reports/temperature/rangeDateReport',
              component: () => import('@/views/dashboard/reports/temperature/RangeDateReport'),
              meta: {
               roles: ['Admin'],
             },
            },
             {
              name: 'tankRangeDateReport',
              path: 'reports/tank/rangeDateReport',
              component: () => import('@/views/dashboard/reports/tank/RangeDateReport'),
              meta: {
               roles: ['Admin'],
             },
            },
             {
              name: 'compliceTemperatureReport',
              path: 'reports/temperature/compliceTemperature',
              component: () => import('@/views/dashboard/reports/temperature/CompliceReport'),
              meta: {
               roles: ['Admin'],
             },
            },
            {
              name: 'users',
              path: 'users/userList',
              component: () => import('@/views/dashboard/users/UserList'),
              meta: {
               roles: ['Admin'],
             },
            },
            {
              name: 'user',
              path: 'users/user/:id',
              component: () => import('@/views/dashboard/users/User'),
              meta: {
               roles: ['Admin'],
             },
            },
      ],
    },
    {
      path: '*',
      component: () => import('@/views/pages/Index'),
      children: [
        {
          name: '404 Error',
          path: '',
          component: () => import('@/views/pages/Error'),
          meta: {
            notRequiresAuth: true,
          },
        },
      ],
    },
  ],
})

router.beforeEach((to, from, next) => {
  const user = JSON.parse(window.localStorage.getItem('user')) // store.state.user
  if (to.matched.some(record => record.meta.notRequiresAuth)) {
    return next()
  }

  if (store.getters.isLoggedIn) {
    if (!user.roles) {
      next()
      return
    } else {
      const roles = to.meta.roles

      for (var i = 0; i < roles.length; i++) {
        for (var j = 0; j < user.roles.length; j++) {
          if (roles[i] === user.roles[j].name) {
            next()
            return
          }
        }
      }
      return next({
        path: '/pages/login',
        query: { redirect: to.fullPath }, // Store the full path to redirect the user to after login
      })
    }
  }
  next('/pages/login')
  // next({
  //     path: '/page/login',
  //     query: { redirect: to.fullPath }, // Store the full path to redirect the user to after login
  //   })
})

export default router
